import baseConfig from '@config/base.config';
import urlUtils from '@utils/url.utils';
import { Experience } from '@models/experience/experience';
import { useOtherServiceApi } from '@models/common/useOtherServiceApi';
import useVideo from './useVideo';

const deviceTypeMap = {
    pc: { width: 1440, height: 768 },
    mobile: { width: 375, height: 667 },
    tablet: { width: 767, height: 1024 }
};
interface ThumbnailBase {
    addFix: false;
    deviceType: 'pc' | 'mobile' | 'tablet';
}

interface ThumbnailUrl extends ThumbnailBase {
    url: string;
    width?: number;
    height?: number;
    isDelay?: boolean;
    // customDomSelector?: string;
}

interface ThumbnailHTML extends ThumbnailBase {
    htmlString: string;
    customDomSelector: string;
}

/*
没popup stickybar
{
    url: string;
    width: number;
    height: number;
    addFix: false;
    deviceType: 'pc' | 'mobile' | 'tablet';
}

有popup stickybar
{
    htmlString: string;
    customDomSelector: string;
    addFix: false;
    deviceType: 'pc' | 'mobile' | 'tablet';
}

重定向
{
    url: string;
    width: number;
    height: number;
    addFix: false;
    deviceType: 'pc';
}
*/

type Thumbnail = XOR<ThumbnailUrl, ThumbnailHTML>;

export default function useVersionScreenshot(experience: Experience, callback?: () => void) {
    const isReactive = experience.engageType === 'REDIRECT';
    const queryParams: any = {};

    // 执行回调
    const updateQueryParams = (versioonId: string) => {
        delete queryParams[versioonId];
        if (Object.keys(queryParams).length === 0) {
            typeof callback === 'function' && callback();
        }
    };

    // 遍历生成截图请求参数
    // 重定向控制组也需要截图
    experience?.versions?.forEach(version => {
        if (
            (!isReactive && version.controlGroup) ||
            !version?.terminals ||
            version?.terminals.length === 0
        )
            return;

        // 有pc优先截
        const terminals = version?.terminals
            ?.slice()
            ?.sort((terminalA, terminalB) =>
                terminalA.type === 2 && terminalB.type !== 2 ? -1 : 1
            );

        const thumbnail = { addFix: false, deviceType: 'pc' } as Thumbnail;

        // 优先截 popup然后是stickybar
        let targetTerminal = terminals.find(
            terminal => terminal.popup?.length > 0 || terminal.stickybar?.length > 0
        );
        if (targetTerminal) thumbnail.customDomSelector = `[data-menu-action="insert.popup"]`;
        else {
            // 没有就截整页的图
            // 重定向截图url与其他不一致
            const baseURL =
                experience.engageType === 'REDIRECT'
                    ? version?.terminals?.[0]?.redirect?.previewUrl
                    : experience.baseURL;
            thumbnail.url = urlUtils.updateUrlParams(
                baseURL,
                baseConfig.ENGAGE_CONTROL_GROUP_TOKEN,
                '1'
            );
        }

        if (!targetTerminal) {
            if (terminals?.[0])
                thumbnail.deviceType =
                    terminals[0].type === 2 ? 'pc' : terminals[0].type === 1 ? 'mobile' : 'tablet';
            thumbnail.width = deviceTypeMap[thumbnail.deviceType].width;
            thumbnail.height = deviceTypeMap[thumbnail.deviceType].height;
        } else {
            const targetPop: any[] =
                targetTerminal.popup.length > 0 ? targetTerminal.popup : targetTerminal.stickybar;
            const target: any | undefined = targetPop?.[0];

            const video = useVideo(target?.widgets?.[0]?.widgetNodes?.html);
            if (video) {
                thumbnail.isDelay = true;
            }

            thumbnail.htmlString = `
                <body>
                    <style type="text/css">
                        ${target?.widgets?.[0]?.widgetNodes?.commonStyle || ''}
                        ${target?.widgets?.[0]?.widgetNodes?.css || ''}
                        * {
                            animation: none !important;
                            transition: none !important;
                        }
                    </style>
                    ${target?.widgets?.[0]?.widgetNodes?.html}
                    ${video ? video : ''}
                </body>
            `;
        }
        queryParams[version.id] = {
            service: 'draw',
            type: 'post',
            path: '/api/html2img',
            body: thumbnail
        };
    });

    // 循环调用截图
    Object.keys(queryParams).forEach(versioonId => {
        const { onOtherServiceApiResult, onOtherServiceApiError } = useOtherServiceApi(
            queryParams[versioonId]
        );
        onOtherServiceApiResult(data => {
            if (data.data.otherServiceApi.url) {
                const version = experience.versions.find(version => version.id === versioonId);
                version && (version.screenshot = data.data.otherServiceApi.url);
            }
            updateQueryParams(versioonId);
        });
        onOtherServiceApiError(() => updateQueryParams(versioonId));
    });
}
